import React from 'react';
import './app.css';
import { connect } from 'react-redux';
import { Router, Route } from 'react-router-dom';
import * as microsoftTeams from '@microsoft/teams-js';
import LoaderComponent from './components/loader/loader';
import { CONFIG } from './helper/config';
import CreateNotification from './components/notifications/create-notification/create-notification';
import NotificationList from './components/notifications/notification-lists/notification-lists';
import TabConfig from './components/tab-config/tab-config';
import history from './helper/history';
import { getQueryVariable } from './helper/utilities';
import {setTheme} from './actions/view.actions';
import NarrativeBoardTab from './components/narrative-board/narrative-board-tab/narrative-board-tab';
import NarrativeBoardDropdown from './components/narrative-board/narrative-board-dropdown/narrative-board-dropdown';
import BeagleCards from './components/card-library/card-library';
import PvpCards from './components/pvp-card/pvp-card';
import Home from './components/home/home';
import { errorBoundaryService } from './services/error-boundary.service';
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from './components/common/error-boundary/error-boundary';
import { setCardLibraryMessage } from './actions/card-library.actions';
import EditNotification from './components/notifications/edit-notification/edit-notification';
import  DownloadCsv  from './components/download-csv/download-csv';
import  FetchUserLocation  from './components/fetch-user-location/fetch-user-location';

interface IProps {
  active_loader: boolean;
  loading_time: number;
  theme:string;
  sessionId:string;
  setTheme:(arg:string)=>void;
}
interface IState {
team_context:any;
token:string;
}

class App extends React.Component<IProps,IState> {
  constructor(props) {
    super(props);
    this.state = { team_context:{},token:'' };
}

  UNSAFE_componentWillMount() {
    // If you are deploying your site as a MS Teams static or configurable tab,
    // you should add “?theme={theme}” to your tabs URL in the manifest.
    // That way you will get the current theme before it’s loaded; getContext()
    // is called only after the tab is loaded, which will cause the tab to flash
    // if the current theme is different than the default.
    this.updateTheme(getQueryVariable('theme'));
    // If you are not using the MS Teams Javascript SDK, you can remove this entire
    // if block, but if you want theme changes in the MS Teams client to propagate
    // to the tab, leave it here.
    // if (inTeams()) {
      // microsoftTeams.initialize();
    // }
  }

  updateTheme = (theme_str : string) => {
    theme_str = (theme_str !== '') ? theme_str : 'light';
    this.props.setTheme(theme_str);
  }

   logError = (error: Error, info: { componentStack: string }) => {

    microsoftTeams.app.initialize()
      .then(() => { console.log("Teams SDK initialized")})
      .catch((err) => console.error("Initialization failed:", err));

      let team_context:any={}
      microsoftTeams.app.getContext()
      .then((context) => {
        console.log("User context:", context)
        team_context.user_id = context.user?.id;
        team_context.user_name = context.user?.userPrincipalName;
        team_context.tenant_id = context.user?.tenant?.id;
        team_context.teams_channel_id = context.channel?.id;
        team_context.channelId = 'msteams';

        microsoftTeams.authentication.getAuthToken()
        .then((token) => {
          console.log("Token received: ", token);
          let session_id = this.props.sessionId ? this.props.sessionId : new Date().toString();
            let error_obj={
              tenant_id:team_context?.tenant_id,
              user_id:team_context?.user_id,
              session_id:session_id,
              data:{
                error:{
                  logError:`${error.message}`,
                  info:info?JSON.stringify(info):'',
                  stack:error.stack
                },
              }
            }
        
            errorBoundaryService.logNewError(token,error_obj).then((result) => {
            return result
          }).catch(err => {
            setCardLibraryMessage(err)
          })
            this.setState({
              team_context: team_context,
              token: token,
            })
        })
        .catch((error) => {
          console.error("Failed to get token: ", error);
        });
      })
      .catch((err) => console.error("Failed to get context:", err));
    
  };

  /**
   * This function is called when the component is mounted. It initializes the
   * microsoft teams app and gets the context of the app. It also gets the
   *  authentication token and sets the team context and token in the state.
   */
  render() {
    const { active_loader, loading_time } = this.props;
    let no_padding = (history.location.pathname === CONFIG.PATH.NARRATIVEBOARD ||history.location.pathname === CONFIG.PATH.HOME) ? 'no-padding':'';
    return (
      <div  data-testid='app-comp' id='app_comp' className={`theme-${this.props.theme}`}>
      <div className={`router-div ${no_padding}`} >
        <Router history={history} >
        <ErrorBoundary fallback={ 
          <ErrorFallback/>
          } onError={this.logError}>
          <Route exact path={CONFIG.PATH.CREATENOTIFICATION} component={CreateNotification} />
          <Route exact path={CONFIG.PATH.EDITNOTIFICATION} component={EditNotification} />
          <Route exact path={CONFIG.PATH.NOTIFICATIONS} component={NotificationList} />
          <Route exact path={CONFIG.PATH.NARRATIVEBOARD} component={NarrativeBoardTab} />
          <Route exact path={CONFIG.PATH.ADDCARDTONARRATIVEBOARD} component={NarrativeBoardDropdown} />
          <Route exact path={CONFIG.PATH.TABCONFIG} component={TabConfig} />
          <Route exact path={CONFIG.PATH.CARDLIBRARY} component={BeagleCards} />
          <Route exact path={CONFIG.PATH.PVPCARD} component={PvpCards} />
          <Route exact path={CONFIG.PATH.HOME} component={Home} />          
          <Route exact path={CONFIG.PATH.DOWNLOADCSVROUTE} component={DownloadCsv} />
          <Route exact path={CONFIG.PATH.GETLOCATION} component={FetchUserLocation} />
          </ErrorBoundary>
        </Router>
      </div>
      <LoaderComponent active_loader={active_loader} loading_time={loading_time} />
    </div>
    );
  }
}

// This function maps the state of the Redux store to the props of the App component.
// It takes the state as an argument and returns an object with the active_loader,
const mapStateToProps = (state: any) => ({
  active_loader: state.viewState.active_loader,
  loading_time: state.viewState.loading_time,
  theme: state.viewState.theme,
  sessionId:state.viewState.sessionId
});

export default connect(mapStateToProps, {setTheme})(App);
